module.exports = __webpack_public_path__ + "static/avatar-1cb7e05eadfb17bc19609ec871912a55.png";